const U = ["", "UN", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ", "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISÉIS", "DIECISIETE", "DIECIOCHO", "DIECINUEVE", "VEINTE"];
const D = ["", "", "", "TREINTA", "CUARENTA", "CINCUENTA", "SESENTA", "SETENTA", "OCHENTA", "NOVENTA"];
const C = ["", "CIENTO", "DOSCIENTOS", "TRESCIENTOS", "CUATROCIENTOS", "QUINIENTOS", "SEISCIENTOS", "SETECIENTOS", "OCHOCIENTOS", "NOVECIENTOS"];

function decenas(n) {
    if (n <= 20) return U[n];
    const d = Math.floor(n / 10), u = n % 10;
    if (d === 2) return u ? `VEINTI${U[u]}` : "VEINTE";
    return u ? `${D[d]} Y ${U[u]}` : D[d];
}

function centenas(n) {
    if (n === 100) return "CIEN";
    const c = Math.floor(n / 100), r = n % 100;
    return `${C[c]}${c && r ? " " : ""}${r ? decenas(r) : ""}`.trim();
}

function miles(n) {
    const m = Math.floor(n / 1000), r = n % 1000;
    const t = m === 0 ? "" : m === 1 ? "MIL" : `${centenas(m)} MIL`;
    return `${t}${t && r ? " " : ""}${r ? centenas(r) : ""}`.trim();
}

function millones(n) {
    const mm = Math.floor(n / 1e6), r = n % 1e6;
    const t = mm === 0 ? "" : mm === 1 ? "UN MILLÓN" : `${miles(mm)} MILLONES`;
    return `${t}${t && r ? " " : ""}${r ? miles(r) : ""}`.trim();
}

export function numeroALetras(value) {
    const abs = Math.abs(Number(value) || 0);
    const n = Math.floor(abs);
    const cents = Math.round((abs - n) * 100);
    const words = n === 0 ? "CERO" : millones(n);
    return `${words} CON ${String(cents).padStart(2, "0")}/100 DÓLARES DE LOS ESTADOS UNIDOS DE AMÉRICA`;
}

export function parseMoney(s) {
    const n = parseFloat(String(s ?? "").replace(/[^0-9.,-]/g, "").replace(/,/g, ""));
    return Number.isNaN(n) ? 0 : n;
}
